"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingComponent = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_redux_1 = require("react-redux");
var useClient_1 = require("../hooks/useClient");
var BillingComponent = function () {
    var _a;
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var client = (0, useClient_1.useClient)().client;
    return ((0, jsx_runtime_1.jsx)("div", { className: "w-auto", children: (0, jsx_runtime_1.jsx)("div", { className: "flex flex-col lg:w-[1350px] overflow-y-scroll", children: (0, jsx_runtime_1.jsx)("stripe-pricing-table", { "pricing-table-id": process.env.STRIPE_PRICING_TABLE_ID, "publishable-key": process.env.STRIPE_PUBLISHABLE_KEY, "client-reference-id": (_a = client === null || client === void 0 ? void 0 : client.integration_settings) === null || _a === void 0 ? void 0 : _a.payment_engine_id, "customer-email": user === null || user === void 0 ? void 0 : user.email }) }) }));
};
exports.BillingComponent = BillingComponent;
